<template>
  <v-container fluid>
    <v-btn @click="clearAggregate()">Clear Aggregate</v-btn>
    <v-btn @click="clearCache()">Clear Cache</v-btn>
    <v-btn @click="clearLog()">Clear Log</v-btn>
    <v-btn @click="clearTask()">Clear Task</v-btn>
    <v-btn @click="clearFastCache()">Clear Fast Task</v-btn>
    <v-btn @click="dumpToDBTask()">Dump to DB</v-btn>

  </v-container>
</template>

<script>
import {useAggregateStore} from "@/store/CommonStore/baseAggregateStore";

export default {
  name: "SystemPanel",

  components: {
  },

  methods: {
    clearAggregate() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'clear_aggregate',
        callBack: null
      })
    },
    clearCache() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'clear_cache',
        callBack: null
      })
    },
    clearFastCache() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'clear_fast_cache',
        callBack: null
      })
    },
    clearLog() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'clear_log',
        callBack: null
      })
    },
    clearTask() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'clear_task',
        callBack: null
      })
    },
    dumpToDBTask() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'dump_to_db',
        callBack: null
      })
    },
  },

  mounted() {
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeAggregate: null,
      storeName: 'SystemPanel',
      dtoActionCommand: 'SystemPanelActionCommandDTO',
    }
  },
}
</script>

<style scoped>

</style>